<!--
*@XzfxPage 新增分析
*@author Ys
*@date 2023/1/10 11:22
-->
<template>
    <div style="margin-top: 35px;">
      <el-form ref="taskForm" :model="taskData" :rules="rules" align="left" label-width="141px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="xmmc">
              <el-input v-model="taskData.xmmc" style="width: 95%" placeholder="请输入项目名称(注：发改委备案名称)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目代码" prop="xmdm">
              <el-input v-model="taskData.xmdm"  style="width: 95%" placeholder="请输入项目代码(注：发改委备案代码)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="lxr" >
              <el-input v-model="taskData.lxr" style="width: 95%"  placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="lxdh">
              <el-input v-model="taskData.lxdh"  style="width: 95%" placeholder="请输入联系人联系电话" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="shp数据包" align="left" label-width="145px">
              <el-upload
                accept=".zip"
                :file-list="shpList"
                ref="shpUpload"
                :action="fileUploadPath"
                :on-remove="shpOnRemove"
                :limit="1"
                :on-exceed="showExceedinfo"
                :auto-upload="true"
                :on-success="uploadSuccess"
                :before-upload="shpBeforeUpload">
                <el-button size="mini" type="primary" icon="el-icon-upload">上传文件</el-button>
                <div slot="tip" class="el-upload__tip">请将<span
                  style="color: #ff2940;font-weight: bold">SHP</span>图形数据，放置在一个文件夹内(请勿嵌套二级文件夹)，压缩后上传。具体SHP文件要求，见
                  <a style="text-decoration: none;font-size: 16px;font-weight: bold"href="./static/SHP_DESCRIPTION.pdf"  title="点击查看shp文件说明"target="_blank"><span style="color: #ff1515;">《SHP文件说明》</span></a>
<!--                  <a style="text-decoration: none;font-size: 16px;font-weight: bold"href=" ../../../../../static/SHP_DESCRIPTION.pdf"  title="点击查看shp文件说明"target="_blank"><span style="color: #ff1515;">《SHP文件说明》</span></a>-->
                </div>
              </el-upload>
              <el-button v-show="taskData.shpPath && !showCheckedMessage" size="small"  type="success" icon="el-icon-s-tools" @click="checkShpData">验证数据</el-button>
              <div v-show="showCheckedMessage">
                <ol v-show="!checkedMessage">
                  <li v-for="item in dlwzList"  :class="checkStyle">
                    {{item.szwz}}，占地面积：{{item.zdmj.toFixed(2)}}平方米
                  </li>
                </ol>
               <span style="color: red"> {{checkedMessage}}</span></div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="用途" align="left" prop="yt">
              <el-input v-model="taskData.yt" type="textarea"  placeholder="请输入项目用途"
                        :autosize="{minRows: 4, maxRows: 4}"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
        <p align="left" id="note">注：1、分析图斑不可超过50公顷，超过50公顷需与榆林市地理信息中心进行联系申请<br>
        联系人：信息中心    电话：0912-3592615 <br>
        2、单个账号每天进行任务数量最多只有2次，请确认无误后再申请分析</p>
      <div style="text-align: center;margin-top: 30px">
        <el-button  type="success" @click="addTask" style="margin-right: 15%;width: 98px">申请</el-button>
        <el-button  type="primary" @click="showKjfxRwList" style="margin-right: 15%" >查看记录</el-button>
        <el-button  @click="goToFxfa" style="margin-right: 15%;width: 98px">返回</el-button>
      </div>
    </div>
</template>

<script>
  import API from '../../../../api/ApiConfig'
  import {ajaxPost} from '../../../../util/AjaxhttpRequest'
  import $ from 'jquery'
  import Cookie from 'cookies-js'
  export default {
    name: 'FxrwAddPage',
    props: ['checkedFxfa'],
    components: {},
    data () {
      return {
        checkStyle:'',
        dlwzList:[],
        showCheckedMessage:false,
        checkedMessage:'',
        token: Cookie.get("wwJcptToken"),
        taskData:{
          shpPath:'',
          shpMc:'',
        },
        rules:{
          xmmc: [{required: true, message: '请输入项目名称(注：发改委备案名称)', trigger: 'blur'}],
          xmdm: [{required: true, message: '请输入项目代码(注：发改委备案代码)', trigger: 'blur'}],
          lxr: [{required: true, message: '请输入联系人', trigger: 'blur'}],
          lxdh: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
          yt: [{required: true, message: '请输入用途', trigger: 'blur'}],

        },
        shpList: [],
        fileUploadPath:'',
        fileDownPath:'',
      }
    },
    mounted () {
      this.fileUploadPath = API.fileUpload;
      this.fileDownPath = API.fileDownLoad;
      this.taskData.fxfa=this.checkedFxfa;
    },
    methods: {
      checkShpData(){
        ajaxPost(API.KjfxProvider,"checkShpData",[this.token,this.taskData.shpPath]).then(result=>{
          console.log(result)
          this.dlwzList=JSON.parse(result)
          this.showCheckedMessage=true;
          this.checkedMessage='';
          this.checkStyle='normalMessage'
        }).catch(err=>{
          this.showCheckedMessage=true;
          this.checkedMessage=err;
          this.checkStyle='errorMessage'
        })
      },
      showKjfxRwList(){
        this.$confirm('确认离开当前页面？当前数据未保存，离开后丢失！', '操作确认', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('showRwList');
        })
      },
      addTask(){
        console.log("taskData",this.taskData)
        var self = this;
        self.$refs['taskForm'].validate(valid => {
          if (!valid) return;
          if (!self.taskData.shpPath) {
            this.$message.error('请上传SHP文件数据!');
            return;
          }
          self.$confirm('确认信息无误，创建此任务！', '系统提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (Cookie.get("dllx")=="2" && Cookie.get("certNo")) {
              this.taskData.certNo=Cookie.get("certNo")
            }
          ajaxPost(API.KjfxProvider,"addKjfxTask",[this.token,Cookie.get("dlzh"),JSON.stringify(this.taskData)]).then(result=>{
            self.$message.success("分析任务创建成功");
            self.$emit('showRwList');
          }).catch(err=>{
            self.$message.error(err)
          })
          })
        })
      },
      goToFxfa(){
        this.$confirm('确认返回上一步？当前数据未保存，离开后丢失！', '操作确认', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('backToFxfa');
        })
      },
      shpBeforeUpload(file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        if ( testmsg !== "zip") {
          this.$message.error('请上传zip格式文件!');
          return false
        }
        let isRightSize = file.size / 1024 / 1024 < 50;
        if (!isRightSize) {
          this.$message.error('文件大小超过 50MB')
        }
        return isRightSize
      },
      uploadSuccess(res, file, List) {
        let status = res.status;
        if (status === '-1') {
          this.$message.error('SHP文件上传失败,任务创建失败!');
        } else {
          //上传成功后将文件路径和文件名赋值给表单字段
          this.taskData.shpPath = res.result;
          this.taskData.shpMc = file.name;
          this.showCheckedMessage=false;
        }
      },
      showExceedinfo(){
        this.$message.error("仅支持单个shp压缩包上传解析(可包含多个图斑)")
      },
      shpOnRemove(file) {
        ajaxPost(API.KjfxCommonProvider,"deleteFastDfsFile",[this.token,file.response.result]).then(res=>{
          this.$message.success(res);
          this.taskData.shpPath ="";
          this.taskData.shpMc = "";
          this.showCheckedMessage=false;
        }).catch(err=>{
          this.$message.error(err)
        });
      },
    },
  }
</script>

<style scoped>
#note{
  padding-left: 70px;
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 28px;
  color: rgb(255, 1, 1);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 40px;
  text-decoration: none;
}
  /deep/ .el-form-item__label{
    font-family: SourceHanSansSC;
    font-weight: 400;
    font-size: 28px;
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0px;
    line-height: 40px;
    text-decoration: none;
  }
  .normalMessage{
    color: #000000;font-size: 15px;
  }
  .errorMessage{
    color: #ff231c;font-size: 15px;
  }
  /deep/ .el-upload-list{
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/kjfx/main/components/FxrwAddPage.vue